module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('demo', {
    staticClass: "select-demo",
    attrs: {
      "title": "Select"
    }
  }, [_c('demo-item', {
    attrs: {
      "name": "size",
      "description": "大小",
      "code": _vm.code
    },
    slot: "left"
  }, [_c('Select', {
    attrs: {
      "data": [2, 3, 4],
      "size": 'sm'
    },
    model: {
      value: (_vm.test),
      callback: function($$v) {
        _vm.test = $$v
      },
      expression: "test"
    }
  }), _vm._v(" "), _c('Select', {
    attrs: {
      "data": [2, 3, 4],
      "size": 'md'
    },
    model: {
      value: (_vm.test),
      callback: function($$v) {
        _vm.test = $$v
      },
      expression: "test"
    }
  }), _vm._v(" "), _c('Select', {
    attrs: {
      "data": [2, 3, 4],
      "size": 'lg'
    },
    model: {
      value: (_vm.test),
      callback: function($$v) {
        _vm.test = $$v
      },
      expression: "test"
    }
  })], 1), _vm._v(" "), _c('demo-item', {
    attrs: {
      "name": "labelFloat",
      "description": "标题浮动",
      "code": _vm.float_code
    },
    slot: "right"
  }, [_c('Select', {
    attrs: {
      "data": [2, 3, 4],
      "float": true,
      "label": '我是标题'
    },
    model: {
      value: (_vm.float_test),
      callback: function($$v) {
        _vm.float_test = $$v
      },
      expression: "float_test"
    }
  }), _vm._v(" "), _c('Select', {
    attrs: {
      "data": [2, 3, 4],
      "float": true
    },
    model: {
      value: (_vm.float_test),
      callback: function($$v) {
        _vm.float_test = $$v
      },
      expression: "float_test"
    }
  }), _vm._v(" "), _c('Select', {
    attrs: {
      "data": [2, 3, 4]
    },
    model: {
      value: (_vm.float_test),
      callback: function($$v) {
        _vm.float_test = $$v
      },
      expression: "float_test"
    }
  })], 1), _vm._v(" "), _c('demo-item', {
    attrs: {
      "name": "status",
      "description": "状态",
      "code": _vm.disabled_code
    },
    slot: "left"
  }, [_c('Select', {
    attrs: {
      "data": [2, 3, 4],
      "disabled": true
    }
  }), _vm._v(" "), _c('Select', {
    attrs: {
      "data": [2, 3, 4]
    },
    model: {
      value: (_vm.disabled_test),
      callback: function($$v) {
        _vm.disabled_test = $$v
      },
      expression: "disabled_test"
    }
  })], 1), _vm._v(" "), _c('demo-item', {
    attrs: {
      "name": "color",
      "description": "颜色",
      "code": _vm.color_code
    },
    slot: "right"
  }, [_c('Select', {
    attrs: {
      "data": [2, 3, 4]
    },
    model: {
      value: (_vm.color_test),
      callback: function($$v) {
        _vm.color_test = $$v
      },
      expression: "color_test"
    }
  }), _vm._v(" "), _c('Select', {
    attrs: {
      "data": [2, 3, 4],
      "color": '#4fae9B'
    },
    model: {
      value: (_vm.color_test),
      callback: function($$v) {
        _vm.color_test = $$v
      },
      expression: "color_test"
    }
  }), _vm._v(" "), _c('Select', {
    attrs: {
      "data": [2, 3, 4],
      "color": 'rgb(0, 160, 233)'
    },
    model: {
      value: (_vm.color_test),
      callback: function($$v) {
        _vm.color_test = $$v
      },
      expression: "color_test"
    }
  })], 1), _vm._v(" "), _c('demo-item', {
    attrs: {
      "name": "custom",
      "description": "自定义行为",
      "code": _vm.custom_code
    },
    slot: "left"
  }, [_c('p', {
    staticClass: "tip"
  }, [_vm._v("选择器1 无触发close事件")]), _vm._v(" "), _c('Select', {
    model: {
      value: (_vm.custom_test),
      callback: function($$v) {
        _vm.custom_test = $$v
      },
      expression: "custom_test"
    }
  }, _vm._l((4), function(n) {
    return _c('p', {
      staticClass: "custom-option",
      on: {
        "click": function($event) {
          _vm.custom_test = "自定义选项" + n
        }
      }
    }, [_vm._v("自定义选项 " + _vm._s(n))])
  })), _vm._v(" "), _c('p', {
    staticClass: "tip"
  }, [_vm._v("选择器2 触发close事件")]), _vm._v(" "), _c('Select', {
    ref: 'select',
    model: {
      value: (_vm.custom_test),
      callback: function($$v) {
        _vm.custom_test = $$v
      },
      expression: "custom_test"
    }
  }, _vm._l((4), function(n) {
    return _c('p', {
      staticClass: "custom-option",
      on: {
        "click": function($event) {
          _vm.custom_test = "自定义选项" + n, _vm.$refs.select.$emit('close')
        }
      }
    }, [_vm._v("自定义选项 " + _vm._s(n))])
  })), _vm._v(" "), _c('br'), _vm._v(" "), _c('Btn', {
    nativeOn: {
      "click": function($event) {
        _vm.$refs.select.$emit('form-verify')
      }
    }
  }, [_vm._v("验证选择器1")]), _vm._v(" "), _c('Btn', {
    nativeOn: {
      "click": function($event) {
        _vm.$root.$emit('form-verify')
      }
    }
  }, [_vm._v("验证所有选择器")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7a1f8850"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/demo/Select.vue
// module id = 678
// module chunks = 0